import createEatUp from "@/app";
import MultilocationApp from "./MultilocationApp.vue";
import router from "./router";
import { EAT_UP_PAGES } from "@/types";

createEatUp(MultilocationApp, router, EAT_UP_PAGES.MULTILOCATION);
